var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_478_9202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.88 29.48H0V58.36H28.88V29.48Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.88 55.29H0V58.36H28.88V55.29Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6105 29.48H29.7305V58.36H58.6105V29.48Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6105 55.29H29.7305V58.36H58.6105V55.29Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6007 0H16.7207V28.88H45.6007V0Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6007 25.8H16.7207V28.8701H45.6007V25.8Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.59 20.43V0H25.16L45.59 20.43Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8793 49.83V29.48H8.5293L28.8793 49.83Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6095 49.4V29.48H38.6895L58.6095 49.4Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5091 29.48H11.3691V38.3H17.5091V29.48Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2396 29.48H41.0996V38.3H47.2396V29.48Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.23 0H28.09V8.82H34.23V0Z",
    fill: "#027BC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_478_9202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.61,
    height: 58.36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.10c4c143a6ddf223160a6f0ccd3044c4.svg";
export { ForwardRef as ReactComponent };